const fillParam = (activeFilter, filterKey, filterValues) =>
  activeFilter !== filterKey ? filterValues[filterKey] : undefined;

export default fillParam;
